import { z } from 'zod';

export const UsersSchema = z.object({
  AgentType: z.number(),
  agentid: z.number().optional(),
  agent: z.string().optional(),

  CustomerList: z
    .array(
      z.object({
        CustomerID: z.number(),
        CustomerName: z.string(),
      }),
    )
    .nullable(),

  TypesList: z
    .array(
      z.object({
        TypeID: z.number(),
        TypeName: z.string(),
      }),
    )
    .nullable(),
  DisabledBy: z.number(),
  DisabledDate: z.string(),
  FilterFeatureOn: z.boolean(),

  TimeZone: z.string(),
  TimeZoneOffset: z.string(),
  archivetime: z.string(),
  customer: z.number(),
  eclassid: z.number(),
  email: z.string().email('Invalid email').min(1, 'Email is required'),
  flags: z.number(),
  name: z.string().min(1, 'Name is required'),
  roleid: z.number(),
  phone: z
    .string()
    .min(1, 'Phone number is required')
    .regex(/^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/, 'Invalid phone number format'),
  rolename: z.string().min(1, 'Role is required'),
});

export const PasswordSchema = z
  .object({
    newPassword: z.string().min(1, 'New password is required'),
    confirmPassword: z.string().min(1, 'Confirm password is required'),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: "Passwords don't match",
    path: ['confirmPassword'], 
  });

export const user = {
  AgentType: 0,
  agentid: 0,
  agent: '',
  CustomerList: null,
  TypesList: null,
  DisabledBy: 0,
  DisabledDate: '',
  FilterFeatureOn: false,
  TimeZone: '',
  TimeZoneOffset: '',
  archivetime: '',
  customer: 0,
  eclassid: 0,
  email: '',
  flags: 0,
  name: '',
  phone: '',
  roleid: 0,
  rolename: '',
};
